import {
  QueryTarget,
  searchResourceIds,
  type ResourceIdPage,
  type ResourceIdQueryService,
} from "@/shared/domain/query";

/**
 * Search an org's device ids for `search`, returning the raw ids.
 *
 * Devices go through the unified query endpoints (target `devices`) rather
 * than a bespoke search route: the condition is `device_id CONTAINS <term>`,
 * which matches case-insensitively server-side (SQL `ILIKE`), and `device_id`
 * ordering keeps the page deterministic. An empty search lists the first page.
 */
export function searchDeviceIds(
  queryService: ResourceIdQueryService,
  orgId: string,
  search: string,
  options: { limit: number; signal?: AbortSignal },
): Promise<ResourceIdPage> {
  return searchResourceIds(queryService, {
    orgId,
    target: QueryTarget.Devices,
    idField: "device_id",
    match: "contains",
    sortBy: "device_id",
    sortDirection: "ASC",
    search,
    limit: options.limit,
    signal: options.signal,
  });
}
